import Vue from 'vue';

export default {
    applyToJob(context, { jobUuid, data }) {
        const url = `v1/jobs/${jobUuid}/apply`;
        return Vue.$axios.put(url, data);
    },

    applyToJobAsGuest(context, {jobUuid, data}) {
        const url = `v1/jobs/${jobUuid}/guest-apply`;
        let input = data;

        input = new FormData();

        Object.entries(data).forEach((item) => {
            if (item[0] === 'additional_docs') {
                item[1].forEach((o) => {
                    input.append('additional_docs[]', o);
                });
            } else {
                input.append(item[0], item[1]);
            }
        });
        return Vue.$axios.post(url, input);
    },
};
